module.exports = __webpack_public_path__ + "img/faculty-mike.c7ea65f7.png";